export default "/img/LS.9c277e4b8135dc0c3dd81cbfb8fb4e5b.png";